module.exports = __webpack_public_path__ + "img/goals.cf9ccb6c.png";